import { useEffect, useState } from "react";
import { ref, get } from "firebase/database";
import { db } from "../firebase/firebaseconfig"; // Đường dẫn config của bạn

const Sitemap = () => {
  useEffect(() => {
    const fetchLinks = async () => {
      const domain = "https://habakome-6d2ee.web.app/";
      let xml = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">`;

      // Các danh mục bạn muốn Google quét
      const nodes = ["projects", "news", "products"];
      
      for (const node of nodes) {
        const snapshot = await get(ref(db, node));
        if (snapshot.exists()) {
          const data = snapshot.val();
          Object.values(data).forEach((item) => {
            if (item.slug) {
              const prefix = node === "projects" ? "du-an" : (node === "news" ? "tin-tuc" : "san-pham");
              xml += `
  <url>
    <loc>${domain}/${prefix}/${item.slug}</loc>
    <changefreq>daily</changefreq>
    <priority>0.8</priority>
  </url>`;
            }
          });
        }
      }

      xml += `\n</urlset>`;

      // Ghi đè toàn bộ nội dung trang bằng file XML
      const blob = new Blob([xml], { type: "text/xml" });
      window.location.href = URL.createObjectURL(blob);
    };

    fetchLinks();
  }, []);

  return null; // Không hiển thị gì trên giao diện
};

export default Sitemap;